import { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { MdOutlineSegment } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import { logoutAdmin } from "../../registration_login/actions/sessionActions";
import ApplicationStages from "../applicationstages/components/ApplicationStages";
import GrievanceAdminList from "../masterManagement/components/GrievanceAdminList";
import '../styles/main.css';
import CandidateManagement from "./candidateManagement";
import Dashboard from "./Dashboard";
import DebarManagement from "./DebarManagement";
import MasterManagement from "./MastersManagement";
import DashboardSidebar from "./Sidebar";
import UserManagement from "./UserManagement";
import Reports from "../reports/Reports";
import { getDepartments } from "../../common/actions/commonActions";
import {
    setChangePasswordFlg
} from "../usermanagement/actions/userAction";
import { Dropdown, Modal, Button } from 'react-bootstrap';
import ChangePassword from "../../admin/usermanagement/components/ChangePassword";

const AdminDashboard = () => {
    const [showSidebar, setShowSidebar] = useState(true)
    return (
        <div>
            <LoginHeader showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <div className="d-flex p-2">
                <DashboardSidebar showSidebar={showSidebar} />
                <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/mastermanagement" element={<MasterManagement />} />
                    <Route path="/usermanagement" element={<UserManagement />} />
                    <Route path="/applicationstages" element={<ApplicationStages />} />
                    {/* <Route path="/settings" element={<Settings />} />
                    <Route path="/reports" element={<Reports />} /> */}
                    <Route path="/debarmanagement" element={<DebarManagement />} />
                    <Route path="/candidatemanagement" element={<CandidateManagement />} />
                    {/* <Route path="/application" element={<Application />} /> */}
                    {/* <Route path="/settings" element={<Settings />} /> */}
                    {/* <Route path="/reports" element={<Reports />} /> */}
                    {/* <Route path="/challanmanagement" element={<ChallanManagement/>} /> */}
                    {/* <Route path="/docverification" element={<DocumentVerification/>} /> */}
                    <Route path="/grievance" element={<GrievanceAdminList />} />
                    <Route path="/reports-download" element={<Reports />} />

                </Routes>
            </div>
        </div>
    )
}

const LoginHeader = ({ showSidebar, setShowSidebar }) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const dispatch = useDispatch();

    const { adminDepartments } = useSelector((state) => state.common);

    useEffect(() => {
        dispatch(getDepartments());
    }, [])


    const deptId = session?.deptRoles?.[0]?.deptId;

    const departmentName = adminDepartments?.filter((ele) => ele.id === deptId);


    const firstName = session?.firstName
    const lastName = session?.lastName
    const roleName = session?.roleName
    const naviagate = useNavigate()
    const handleLogout = () => {
        dispatch(logoutAdmin(true, naviagate))
    }

    const [showModal, setShowModal] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);


    return (
        <div className="d-flex justify-content-between align-items-center w-100 bg-color px-4">
            <div className={`text-primary toggle_button sidebar-icon ${showSidebar ? 'bg-color' : ''}`} onClick={() => setShowSidebar(!showSidebar)}>
                <MdOutlineSegment />
            </div>

            <Dropdown align="end">
                <Dropdown.Toggle
                    variant="light"
                    className="border-0 d-flex align-items-center gap-2"
                    id="dropdown-user"
                >

                    <div className="p-2">
                        <div className="fw-bold text-primary">
                            {firstName} {lastName}
                        </div>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Header className="d-flex gap-2 align-items-center">
                        <div className="text-primary rounded-circle  bg-color ms-5 p-2">
                            <FaUser size="1.2rem" />
                        </div>
                    </Dropdown.Header>
                    <Dropdown.Divider />
                    <Dropdown.Item>Department: {departmentName?.[0]?.name}</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item>Role: {roleName}</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => dispatch(setChangePasswordFlg(true))}>
                        Change Password
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => setShowModal(true)}>Logout</Dropdown.Item>
                    {/* <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item> */}
                </Dropdown.Menu>

                <ChangePassword />

            </Dropdown>
            {/* <div className="d-flex gap-4 align-items-center">
                <div className="d-flex gap-2 align-items-center">
                    <div className="text-primary bg-color p-2 rounded-circle">
                        <FaUser size="1.2rem" />
                    </div>
                    <div className="fw-bold text-primary">
                        {firstName} {lastName}
                    </div>
                </div>
                <button className="admin-logout" onClick={handleLogout}>
                    Logout
                </button>
            </div> */}

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="md">
                <Modal.Header className="logout_heading">
                    <Modal.Title className="logout_title">Confirm Logout</Modal.Title>
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => setShowModal(false)}
                    >X</button>
                </Modal.Header>

                <Modal.Body>Are you sure you want to logout?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => {
                        handleLogout();
                        setShowModal(false);
                    }}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AdminDashboard;